import {   Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChildren, } from '@angular/core';
import { CommonService } from "src/app/common.service";
import { FormControlTemplatesDirective } from "../form-control-templates.directive";
import { FormControlTemplatesService } from "../form-control-templates.service";


@Component({
  selector: 'form-dropdown-templates',
  templateUrl: './form-dropdown-templates.component.html',
  styleUrls: ['./form-dropdown-templates.component.scss']
})
export class FormDropdownTemplatesComponent implements OnInit {
  @ViewChildren(FormControlTemplatesDirective)
  templateRefs: QueryList<FormControlTemplatesDirective>;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _formControlTmpltService: FormControlTemplatesService,
    public commonService: CommonService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this._formControlTmpltService.dropDownTmpltRefs = this.templateRefs;
  }
}